<script setup>
const props = defineProps(["content", "title"]);
</script>
<template>
    <modalog
        :has-close-x="true"
        :has-header="!!title"
        :has-footer="false"
        size="large"
    >
        <template #title v-if="title">{{ title }}</template>
        <template #content>
            <div v-html="content"></div>
        </template>
    </modalog>
</template>
